"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var faLock_1 = require("@fortawesome/pro-solid-svg-icons/faLock");
var end2end_1 = require("@hudled/end2end");
var material_1 = require("@mui/material");
var react_stripe_js_1 = require("@stripe/react-stripe-js");
var react_1 = require("react");
var LineButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/LineButton"));
var RecharglyButton_1 = __importDefault(require("atomicComponents/molecules/Buttons/RecharglyButton"));
var Footer_1 = __importDefault(require("../StripeClientAgreement/Footer"));
var CheckoutForm = function (_a) {
    var setupIntentId = _a.setupIntentId, customerId = _a.customerId;
    var stripe = (0, react_stripe_js_1.useStripe)();
    var elements = (0, react_stripe_js_1.useElements)();
    // const [name, setName] = useState<string>('');
    var _b = __read((0, react_1.useState)(), 2), message = _b[0], setMessage = _b[1];
    var _c = __read((0, react_1.useState)(false), 2), isLoading = _c[0], setIsLoading = _c[1];
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var error;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    if (!stripe || !elements) {
                        // Stripe.js has not yet loaded.
                        // Make sure to disable form submission until Stripe.js has loaded.
                        return [2 /*return*/];
                    }
                    setIsLoading(true);
                    return [4 /*yield*/, stripe.confirmSetup({
                            elements: elements,
                            confirmParams: {
                                // payment_method_data: { billing_details: { name } },
                                return_url: "".concat(window.location.href).concat((0, end2end_1.getQParamAttachChar)(window.location.href), "confirmSetupIntent=").concat(setupIntentId),
                            },
                        })];
                case 1:
                    error = (_a.sent()).error;
                    // This point will only be reached if there is an immediate error when
                    // confirming the payment. Otherwise, your customer will be redirected to
                    // your `return_url`. For some payment methods like iDEAL, your customer will
                    // be redirected to an intermediate site first to authorize the payment, then
                    // redirected to the `return_url`.
                    if (error.type === 'card_error' || error.type === 'validation_error') {
                        setMessage(error.message);
                    }
                    else {
                        setMessage('An unexpected error occured.');
                    }
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    // Access the email value like so:
    // onChange={(event) => setEmail(event.value.email)}
    //
    // Prefill the email field like so:
    // options={{ defaultValues: { email: 'foo@bar.com' } }}
    //       <LinkAuthenticationElement id="link-authentication-element" />
    return ((0, jsx_runtime_1.jsxs)("form", __assign({ id: "payment-form", onSubmit: handleSubmit, style: { width: 540, margin: '0 auto' } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ pb: 5 }, { children: (0, jsx_runtime_1.jsx)(LineButton_1.default, __assign({ color: "neutral", size: "large", onClick: function () {
                        window.location.href = "/client-agreement?".concat(new URLSearchParams({ cId: customerId }));
                    } }, { children: "Back to agreement" })) })), (0, jsx_runtime_1.jsx)(react_stripe_js_1.PaymentElement, { id: "payment-element" }), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ pt: 4 }, { children: (0, jsx_runtime_1.jsx)(RecharglyButton_1.default, __assign({ fullWidth: true, size: "large", icon: faLock_1.faLock, type: "submit", id: "submitPaymentMethod", isSending: isLoading || !stripe || !elements }, { children: "Save payment method" })) })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ pt: 5, pb: 10 }, { children: (0, jsx_runtime_1.jsx)(Footer_1.default, {}) })), message && (0, jsx_runtime_1.jsx)("div", __assign({ id: "payment-message" }, { children: message }))] })));
};
exports.default = CheckoutForm;
